import actionTypes from '../constants/action-types';

const folders = (state = [], action) => {
  switch (action.type) {
    case actionTypes.RELOAD_SITE_META:
    case actionTypes.CONNECT_SITE: {
      return action.payload.site.meta.folders || [];
    }

    case actionTypes.ADD_FOLDER: {
      const { folderId, folderName, parentFolderId, locale } = action.payload;

      return [
        ...state,
        {
          id: folderId,
          name: folderName,
          parentFolderId,
          locale,
        },
      ];
    }

    case actionTypes.DELETE_FOLDER: {
      const { folderId } = action.payload;

      return state.filter((folder) => folder.id !== folderId && folder.parentFolderId !== folderId);
    }

    case actionTypes.RENAME_FOLDER: {
      const { folderId, folderName } = action.payload;

      return state.map((folder) => {
        if (folder.id === folderId) {
          return {
            ...folder,
            name: folderName,
          };
        }

        return folder;
      });
    }

    case actionTypes.MOVE_TO_FOLDER: {
      const { itemId, targetParentFolderId } = action.payload;

      const targetFolder = state.find((folder) => folder.id === itemId);

      if (!targetFolder) {
        return state;
      }

      return [
        ...state.filter((folder) => folder.id !== itemId),
        {
          ...targetFolder,
          parentFolderId: targetParentFolderId,
        },
      ];
    }

    default:
      return state;
  }
};

export default folders;
